module.exports = __webpack_public_path__ + "static/img/3.374a154f.png";